/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Aborted_ToastInputs */

const en_video_export_aborted_toast = /** @type {(inputs: Video_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video export was aborted`)
};

const fr_video_export_aborted_toast = /** @type {(inputs: Video_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'exportation video a ete annulee`)
};

const de_video_export_aborted_toast = /** @type {(inputs: Video_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Videoexport wurde abgebrochen.`)
};

const it_video_export_aborted_toast = /** @type {(inputs: Video_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'esportazione del video è stata interrotta`)
};

const ru_video_export_aborted_toast = /** @type {(inputs: Video_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт видео был прерван.`)
};

const es_video_export_aborted_toast = /** @type {(inputs: Video_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se canceló la exportación de vídeo`)
};

const zh_cn2_video_export_aborted_toast = /** @type {(inputs: Video_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频导出已中止`)
};

const ja_video_export_aborted_toast = /** @type {(inputs: Video_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオのエクスポートが中止されました`)
};

const hi_video_export_aborted_toast = /** @type {(inputs: Video_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात प्रक्रिया रोक दी गई।`)
};

const pt_pt2_video_export_aborted_toast = /** @type {(inputs: Video_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A exportação do vídeo foi cancelada.`)
};

/**
* | output |
* | --- |
* | "Video export was aborted" |
*
* @param {Video_Export_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_aborted_toast = /** @type {((inputs?: Video_Export_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_aborted_toast(inputs)
	if (locale === "de") return de_video_export_aborted_toast(inputs)
	if (locale === "it") return it_video_export_aborted_toast(inputs)
	if (locale === "ru") return ru_video_export_aborted_toast(inputs)
	if (locale === "es") return es_video_export_aborted_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_aborted_toast(inputs)
	if (locale === "ja") return ja_video_export_aborted_toast(inputs)
	if (locale === "hi") return hi_video_export_aborted_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_aborted_toast(inputs)
	return en_video_export_aborted_toast(inputs)
});